import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Tab, AppBar, Grid, Tabs, Typography, Box, Zoom } from "@material-ui/core";
import PropTypes from "prop-types";
import ContactsOutlinedIcon from "@material-ui/icons/ContactsOutlined";
import { PanelDatosWeb } from "./PanelDatosWeb";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    padding: 10,
    marginTop: 20
  }
}));
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

export const TabIngresoTitularWeb = ({idTabIngreso, form}) => {

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default" style={{ width: "100%" }}>
        <Grid container direction="row" alignItems="center">
          <Tabs
            value={0}
            variant="scrollable"
            scrollButtons="on"
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable"
          >
            <Tab
              label="Datos Personales"
              icon={
                <ContactsOutlinedIcon />}
              {...a11yProps(0)}
            />
          </Tabs>
        </Grid>
      </AppBar>
      <Zoom style={{ transitionDelay: "100ms" }} in={true}>
        <TabPanel value={0} index={0}>
          <PanelDatosWeb
            idTabIngreso={idTabIngreso}
            idPanel={"idTabIngreso"}
            form={form}
          />
        </TabPanel>
      </Zoom>
    </div>
  );

};
